import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {borderRadius, flex, onDesktop, p, resetWidth, w100} from "@pg-design/helpers-css";
import {Radio, Value} from "@pg-design/radio-v2";

import {SUBSCRIPTION_PERIODS} from "./BdSubscriptionBox";

interface IRPClientCheckboxProps {
    selectedPeriod: SUBSCRIPTION_PERIODS;
    onChange: (val: SUBSCRIPTION_PERIODS) => void;
}

export const SubscriptionPeriodRadio = ({selectedPeriod, onChange}: IRPClientCheckboxProps) => {
    const {t} = useTranslation();

    const options: {value: SUBSCRIPTION_PERIODS; label: string}[] = [
        {
            value: "monthly",
            label: t("pricing.monthly")
        },
        {
            value: "annually",
            label: t("pricing.annually")
        }
    ];

    return (
        <div css={card}>
            <Radio
                onChange={(_, value: Value) => onChange(value as SUBSCRIPTION_PERIODS)}
                options={options}
                value={selectedPeriod}
            />
        </div>
    );
};

const card = css`
    ${borderRadius(1)};
    ${p(1)};
    ${flex("center", "flex-start")};
    min-height: 40px;
    background: #fff;
    ${w100};

    ${onDesktop(css`
        ${resetWidth};
    `)}
`;
